<template>
  <el-form
    ref="form"
    :rules="rules"
    :model="form"
    label-width="110px"
    size="small"
    label-suffix=": "
  >
    <el-form-item prop="name">
      <template slot="label">
        <el-tooltip class="item" effect="dark" placement="right-start" :visible-arrow="false">
          <span>
            {{ $t('Product.productFuncName') }}
            <svg class="icon">
              <use xlink:href="#icon-question1"></use></svg
          ></span>
          <template slot="content">
            {{ $t('Product.tips8') }} <br />
            {{ $t('Product.tips9') }}<br />
            {{ $t('Product.tips10') }}
          </template>
        </el-tooltip>
      </template>
      <el-input
        v-model="form.name"
        :placeholder="$t('Common.maxLengthTips16')"
        :maxlength="16"
        @blur="setLangLocal"
      >
      </el-input>
      <hl-button type="text" @click="this.setLang" style="margin-left: 8px">{{
        $t('Common.setLang')
      }}</hl-button>
    </el-form-item>
    <el-form-item prop="identifier">
      <template slot="label">
        <el-tooltip class="item" effect="dark" placement="right-start" :visible-arrow="false">
          <span>
            {{ $t('Product.identifier') }}
            <svg class="icon">
              <use xlink:href="#icon-question1"></use></svg
          ></span>
          <template slot="content">
            {{ $t('Product.tips11') }} <br />
            {{ $t('Common.maxLengthTips16') }}
          </template>
        </el-tooltip>
      </template>
      <el-input
        v-model="form.identifier"
        :placeholder="$t('Common.maxLengthTips16')"
        :maxlength="16"
      >
      </el-input>
    </el-form-item>
    <el-form-item :label="$t('Product.command')" prop="cmd">
      <el-input v-model="form.cmd" :placeholder="$t('Product.command')"> </el-input>
    </el-form-item>
    <el-form-item :label="$t('Product.callType')" prop="callType">
      <el-radio-group v-model="form.callType">
        <el-radio label="async">{{ $t('Product.async') }} </el-radio>
        <el-radio label="sync">{{ $t('Product.sync') }} </el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="Hex" prop="hex">
      <el-switch v-model="form.hex"> </el-switch>
    </el-form-item>
    <JsonParamsFromSelect
      :label="$t('Product.inPutParam')"
      v-model="form"
      needComplexDatatype
      jsonProps="inputData"
    />
    <JsonParamsFromSelect
      :label="$t('Product.outPutParam')"
      v-model="form"
      needComplexDatatype
      jsonProps="outputData"
    />
    <el-form-item :label="$t('Common.desc')" prop="desc">
      <el-input type="textarea" :rows="3" v-model="form.desc" :placeholder="$t('Common.desc')">
      </el-input>
    </el-form-item>
    <div style="text-align: right;">
      <hl-button type="border" @click="close">{{ $t('Common.cancel') }}</hl-button>
      <hl-button @click="save" :loading="loading">{{ $t('Common.save') }}</hl-button>
    </div>
    <SetLang
      :row="row"
      v-if="visibleLang"
      @saveLang="saveLang"
      :visible.sync="visibleLang"
    ></SetLang>
  </el-form>
</template>

<script>
import JsonParamsFromSelect from './JsonParamsFromSelect'
import SetLang from './SetLang'
export default {
  props: {
    tslVersionId: {
      type: String
    },
    identifier: {
      type: String
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  components: {
    JsonParamsFromSelect,
    SetLang
  },
  data() {
    const validateName = (rule, value, callback) => {
      if (!/^[a-zA-Z0-9\u4e00-\u9fa5]+[\u4e00-\u9fa5\w-\\.]*$/.test(value)) {
        callback(new Error(`${this.$t('Product.tips12')}`))
      } else {
        callback()
      }
    }
    const validateIdentifier = (rule, value, callback) => {
      if (!/^\w+$/.test(value)) {
        callback(new Error(`${this.$t('Product.tips13')}`))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      locale: localStorage.getItem('locale'),
      form: {
        nameContent: [],
        nameContentObj: {},
        inputData: [],
        outputData: []
      },
      rules: {
        name: [
          { required: true, message: this.$t('Product.productFuncName'), trigger: 'blur' },
          { validator: validateName, trigger: 'blur' }
        ],
        identifier: [
          { required: true, message: this.$t('Product.identifier'), trigger: 'blur' },
          { validator: validateIdentifier, trigger: 'blur' }
        ],
        callType: [{ required: true, message: this.$t('Product.callType'), trigger: 'change' }],
        cmd: [{ required: true, message: this.$t('Product.command'), trigger: 'blur' }]
      },
      visibleLang: false,
      row: []
    }
  },
  created() {
    if (this.identifier) {
      this.getDetail()
    }
  },
  methods: {
    saveLang(nameObj) {
      this.$set(this.form, 'nameContent', nameObj.nameContent)
      this.$set(this.form, 'nameContentObj', nameObj.nameContentObj)
      this.$set(this.form, 'name', nameObj.nameContentObj[this.locale])
    },
    setLangLocal() {
      this.$set(this.form.nameContentObj, this.locale, this.form.name)
    },
    setLang() {
      let arr = []
      if (this.form.nameContent.length > 0) {
        arr = JSON.parse(JSON.stringify(this.form.nameContent))
      } else {
        let nameContentKeys = Object.keys(this.form.nameContentObj)
        nameContentKeys.forEach((item) => {
          let newObj = {}
          newObj['language'] = item
          newObj['name'] = this.form.nameContentObj[item]
          arr.push(newObj)
        })
      }
      this.row = arr
      this.visibleLang = true
    },
    close() {
      this.$emit('close')
    },
    getDetail() {
      const parasm = {
        tslVersionId: this.tslVersionId,
        identifier: this.identifier
      }
      this.$ajax
        .get(this.$api.product.product_tsl_service_detail, parasm)
        .then((res) => {
          if (res.data) {
            this.form = {
              ...this.form,
              ...res.data
            }
          }
        })
        .catch(() => {})
    },
    checkForm() {
      let pass
      this.$refs.form.validate((valid) => {
        pass = valid
        if (!valid) return
      })
      return pass
    },
    formatParams(obj) {
      const { dataType } = obj
      let specs = {}
      if (dataType === 'int' || dataType === 'float' || dataType === 'double') {
        specs = {
          min: obj.specs.min,
          max: obj.specs.max,
          unit: obj.specs.unit
        }
      } else if (dataType === 'text') {
        specs = {
          length: obj.specs.length
        }
      } else if (dataType === 'enum') {
        let enumDesc = {}
        // 编辑时需要使用 enumDesc 字段，因为如果不去编辑修改某个参数的话，是不会生成 enumDescArr 字段的。
        if (this.form.tslVersionId) {
          enumDesc = obj.specs.enumDesc
        } else {
          if (obj.specs.enumDescArr) {
            obj.specs.enumDescArr.forEach((item) => (enumDesc[item.key] = item.value))
          }
        }
        specs = {
          enumDesc,
          type: obj.specs.type
        }
      } else if (dataType === 'bool') {
        specs = {
          enumDesc: obj.specs.enumDesc
        }
      } else if (dataType === 'struct') {
        specs = {
          item: obj.specs.item
        }
      } else if (dataType === 'array') {
        let arraySpecs = {
          type: obj.specs.type,
          length: obj.specs.length
        }
        if (obj.specs.type === 'struct') {
          arraySpecs.item = obj.specs.item
        }
        specs = arraySpecs
      }
      return {
        ...obj,
        specs
      }
    },
    save() {
      if (!this.checkForm()) return
      this.loading = true
      let outputData = []
      let inputData = []
      if (this.form.inputData) {
        inputData = this.form.inputData
          .map((item) => {
            return {
              name: item.data.name,
              identifier: item.data.identifier,
              allocated: item.data.allocated
            }
          })
          .filter((item) => item.name && item.identifier)
      }

      if (this.form.outputData) {
        outputData = this.form.outputData
          .map((item) => {
            return {
              name: item.data.name,
              identifier: item.data.identifier,
              allocated: item.data.allocated
            }
          })
          .filter((item) => item.name && item.identifier)
      }

      let params = {
        nameContent: this.form.nameContent,
        tslVersionId: this.tslVersionId,
        name: this.form.name,
        identifier: this.form.identifier,
        callType: this.form.callType,
        desc: this.form.desc,
        cmd: this.form.cmd,
        hex: this.form.hex,
        inputData,
        outputData
      }
      let api = this.isEdit
        ? this.$api.product.product_tsl_service_update
        : this.$api.product.product_tsl_service_add
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      this.$ajax
        .post(api, params, config)
        .then(() => {
          this.$message.success(
            `${this.row ? this.$t('Common.editSuccess') : this.$t('Common.createSuccess')}`
          )
          this.close()
          this.$emit('refresh')
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style></style>
